import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import { initTheme } from '@/components/ThemeToggle';
import { maybeInitSentryFromConsent, SentryErrorBoundary } from '@/lib/observability';

// Samočistenie: appka už nepoužíva service worker. Zabi akúkoľvek "zombie"
// kópiu z minulých PWA buildov (zaseknutý SW + Cache Storage), ktorá by
// inak servírovala starý kód aj po deployi.
//
// VÝNIMKA — 'transformers-cache': odkedy pribudlo sémantické Hľadať (SearchV2 →
// embedEngine.js), appka TERAZ Cache Storage legitímne používa — @huggingface/transformers
// si sem cachuje ~35MB embedding model (env.cacheKey, default názov). Mazanie tohto kľúča
// na KAŽDOM štarte appky (nie len raz po migrácii zo starého PWA) donútilo /hladat re-downloadovať
// model pri každom fresh page load (F5, nová záložka) namiesto použitia cache z minula.
(function purgeStaleAppCopies() {
  const KEEP_CACHES = new Set(['transformers-cache']);
  try {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {});
    }
    if (typeof caches !== 'undefined' && caches.keys) {
      caches.keys()
        .then((keys) => keys.filter((k) => !KEEP_CACHES.has(k)).forEach((k) => caches.delete(k)))
        .catch(() => {});
    }
  } catch (_) { /* best-effort */ }
})();

initTheme();
maybeInitSentryFromConsent().catch(() => {});
if (process.env.NODE_ENV === 'development') {
  // dynamický import → webpack/terser vie CELÚ vetvu (aj devSeed a jeho v2/* strom)
  // odstrániť z produkčného balíka, na rozdiel od statického importu + runtime guardu
  // vo vnútri funkcie (namerané 2026-09-28: statický import netreeshakoval, 112KB navyše)
  import('@/v2/devSeed').then((m) => m.installDevSeed());
}

function ErrorFallback({ resetError }) {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'inherit',
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ fontSize: 22, marginBottom: 8 }}>Niečo sa pokazilo</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 16, fontSize: 14 }}>
          Skús obnoviť stránku. Ak problém pretrváva, daj nám vedieť.
        </p>
        <button
          type="button"
          onClick={resetError}
          style={{
            padding: '10px 18px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--product-primary)',
            color: '#fff',
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Skúsiť znova
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SentryErrorBoundary fallback={ErrorFallback}>
    <App />
  </SentryErrorBoundary>
);
